import Vue from 'vue';
import get from 'lodash.get';
import SiteResourceFactory from '../../projects/resources/SiteResourceFactory';

const businessSiteResource = SiteResourceFactory.create('business');
var resource = Vue.axiosFactory.create({baseURL: 'app/scheduler/'});
var adactiveResource = Vue.axiosFactory.create({baseURL: 'app/adactive/'});

const groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[get(x, key)] = rv[get(x, key)] || []).push(x);
    return rv;
  }, {});
};

function injectSitesInProgressToCustomers(customers, tasks) {
  let tasksByCustomerId = groupBy(tasks, 'customer');
  customers.forEach(c => {
    c.sites_in_progress = (tasksByCustomerId[c._id] || []).length;
  });

  return customers;
}

export default {
  // findTask(taskId) {
  //   return resource({method: 'get', url: 'tasks/' + taskId})
  // },
  findTaskByArticle(articleUid, writerId) {
    return resource({method: 'get', url: 'tasks/by_article/' + writerId + '/' + articleUid});
  },
  async listCustomers(src) {
    return (await resource({method: 'get', url: src + '/list_customers'})).customers;
  },
  async listCustomersInjectedWithSitesInProgress(src) {
    let [customers, tasks] = await Promise.all([this.listCustomers(src), this.listTasks()]);
    return injectSitesInProgressToCustomers(customers, tasks);
  },
  listInjectedAdactiveCustomers() {
    return new Promise((resolve, reject) => {
      return Promise.all([this.listCustomersInjectedWithSitesInProgress('adactive'), adactiveResource({
        method: 'get',
        url: 'list_customers_rankings_stats'
      })]).then(([customers, statsByDomainResponse]) => {
        customers.forEach(c => {
          c.firstPageDelta = (statsByDomainResponse.stats[c.domain] || {}).firstPageDelta;
        });
        return resolve(customers);
      }).catch(reject);
    });
  },
  async listInjectedSeomaticCustomers() {
    let customers = await this.listCustomersInjectedWithSitesInProgress('seomatic');
    let rankingStatsByDomain = await businessSiteResource.getRankingStatsBySite();
    console.log({rankingStatsByDomain})
    customers.forEach(c => (c.firstPageDelta = (rankingStatsByDomain[c.domain] || {}).firstPageDelta));

    return customers;
  },
  updateInterval(customerId, defaultInterval) {
    return resource({method: 'post', url: customerId + '/update_interval', data: {defaultInterval}});
  },
  updateVisibility(customerId, data) {
    return resource({method: 'post', url: customerId + '/update_visibility', data});
  },
  createTask(customerId, params) {
    let data = {params, customerId};

    return resource({method: 'post', url: 'tasks', data: data});
  },
  submitTask(taskId, params) {
    return resource({method: 'post', url: `tasks/${taskId}/submit`, data: {params}});
  },
  listTasks() {
    return resource({method: 'get', url: 'tasks'})
      .then(data => {
        return data.tasks;
      });
  },
  // submitTask(taskId) {
  //   return resource({
  //     method: 'post',
  //     url: 'tasks/' + taskId + '/submit',
  //   });
  // },
  submitTaskByArticleId(articleId) {
    return resource({
      method: 'post',
      url: 'tasks/by_article/submit',
      params: {articleId}
    });
  },
  removeTask(task) {
    return resource({method: 'delete', url: 'tasks/' + task._id});
  },
  // submitSite(data) {
  //   return resource({method: 'post', url: 'make_site', data: data});
  // },
  listUndoneArticles() {
    return resource({method: 'get', url: 'tasks/list_undone_articles'})
  },
  updateTaskForOrderedArticle(task) {
    return resource({
      method: 'post',
      url: `tasks/${task._id}/update_for_ordered_article`,
      data: {params: task.site_params}
    });
  }
};
